import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useRecoilState } from "recoil";
import EditLevel1 from "./EditLevel1";
import EditLevel2 from "./EditLevel2";
import EditLevel3 from "./EditLevel3";
import EditLevel4 from "./EditLevel4";
import EditLevel5 from "./EditLevel5";
import EditLevel6 from "./EditLevel6";
import EditLevel7 from "./EditLevel7";
import EditLevel8 from "./EditLevel8";
import Detail from "../../main/detail/Detail";
import { UseProduct } from "./UseProduct";
import ProgressCom from "../../components/ProgressCom";
import { rsProgress, rsActiveMenu, rsParentChilds } from "../../RecoilStates";
import { useSearchParams } from "react-router-dom";

export default function EditProduct(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  var body = {};
  const [expanded, setExpanded] = React.useState("panel1");
  const navigate = useNavigate();
  const [notBack, setNotBack] = React.useState(false);
  const [fireGetData, setFireGetData] = React.useState(false);
  const location = useLocation();
  const [inputState, setInputState] = React.useState();
  const [productName, setProductName] = React.useState("");
  const { getProductByID, updateProduct } = UseProduct();
  const [searchParams, setSearchParams] = useSearchParams();
  const [parentID, setParentID] = useRecoilState(rsParentChilds);

  useEffect(() => {
    if (searchParams) {
      getProductByID(searchParams.get("id"), (productRes) => {
        setParentID({
          id: productRes.groupID,
          name: productRes.fullGroupName,
        });
        setProductName(productRes.faName);
        setInputState(productRes);
      });
    }
  }, [searchParams]);

  const saveButtonFunc = () => {
    setNotBack(true);
    setFireGetData(true);
  };

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        saveButtonFunc: saveButtonFunc,
        saveButton: true,
        backURL: "/products",
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/products" },
          {
            name: "ویرایش محصول" + " " + productName,
            url: "/products/editproduct",
            websiteID: inputState && inputState.productURL,
          },
        ],
      }}
    >
      {inputState ? (
        <Box>
          <EditLevel1
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel1}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel2
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel2}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel3
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel3}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel4
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel4}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel5
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel5}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel6
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel6}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel7
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel7}
            product={inputState}
            setFire={setFireGetData}
          />
          <EditLevel8
            expanded={expanded}
            setExpanded={setExpanded}
            fire={fireGetData}
            fill={getDataFromLevel8}
            product={inputState}
            setFire={setFireGetData}
          />
        </Box>
      ) : (
        <ProgressCom />
      )}
    </Detail>
  );

  function getDataFromLevel1(level1) {
    body.id = inputState.id;
    body.brandID = level1.brandID;
    body.categoryID = level1.categoryID;
    body.faName = level1.faName;
    body.enName = level1.enName;
    body.companyID = level1.companyID;
    body.countryID = level1.countryID;
    body.licenceCountryID = level1.licenceCountryID;
  }
  function getDataFromLevel2(level2) {
    body.typeID = level2.typeID;
    body.materialID = level2.materialID;
    body.sizeID = level2.sizeID;
    body.colorID = level2.colorID;
    body.tasteID = level2.tasteID;
    body.scentID = level2.scentID;
    body.consumerAge = level2.consumerAge;
    body.countInPack = level2.countInPack;
    body.weight = level2.weight;
    body.shieldID = level2.shieldID;
  }
  function getDataFromLevel3(level3) {
    body.registerCode = level3.registerCode;
    body.gender = level3.gender;
    body.spf = level3.spf;
    body.targetLocationID = level3.targetLocationID;
    body.modelID = level3.modelID;
    body.appropriateID = level3.appropriateID;
  }

  function getDataFromLevel4(level4) {
    body.groupID = level4.groupID;
  }

  function getDataFromLevel5(level5) {
    body.characteristics = level5.characteristics;
    body.warnings = level5.warnings;
    body.appurtenances = level5.appurtenances;
    body.keepConditions = level5.keepConditions;
    body.usages = level5.usages;
  }

  function getDataFromLevel6(level6) {
    body.description = level6.description;
    body.usageWay = level6.usageWay;
    body.sumDescription = level6.sumDescription;
    body.metaDescription = level6.metaDescription;
  }

  function getDataFromLevel7(level7) {
    body.ingredientCount = level7.ingredientCount;
    body.ingredients = level7.ingredients;
  }

  function getDataFromLevel8(level8) {
    body.isNatural = level8.isNatural;
    body.isHerbal = level8.isHerbal;
    body.isTraditional = level8.isTraditional;
    body.isOnlineSell = level8.isOnlineSell;
    body.isSuspend = level8.isSuspend;
    UpdateData();
  }

  function UpdateData() {
    setProgress(true);

    updateProduct(
      body,
      () => {
        if (notBack) {
          getProductByID(searchParams.get("id"), (productRes) => {
            setParentID({
              id: productRes.groupID,
              name: productRes.fullGroupName,
            });
            setProductName(productRes.faName);
            setInputState(productRes);
          });

          setNotBack(false);
          setFireGetData(false);
        } else {
          navigate("/products", {
            state: location.state,
            replace: true,
          });
        }
      },
      setFireGetData
    );
  }
}
